




















import { Component, Vue } from 'vue-property-decorator'
import AuthFooterItem from '@/components/layout/auth/AuthFooterItem.vue'
import leClubLogo from '@/assets/images/logo/logo_leclub_dark.png'
import lesSummitsLogo from '@/assets/images/logo/logo_lessummits_dark.png'
import lesTalentsLogo from '@/assets/images/logo/logo_lestalents_dark.png'
import leFondsLogo from '@/assets/images/logo/logo_lefonds_dark.png'

@Component({
    components: { AuthFooterItem },
})
export default class AuthFooterLayout extends Vue {
    items = [
        { logo: leClubLogo, alt: 'Le Club', url: '/' },
        { logo: leFondsLogo, alt: 'Le Fonds', url: 'https://lefonds.vc/' },
        { logo: lesTalentsLogo, alt: 'Les Talents', url: 'https://lestalents.frenchfounders.com/' },
        { logo: lesSummitsLogo, alt: 'Les Summits', url: 'https://www.frenchfounders.com/lessummits/' },
    ]
}
